import useRequest from "~/composables/use-request";
import { formatIdentityItem, formatPaginatedResponseItems, formatRequestOptions } from "../format";

const SubCategoriesAPI = {
  load(options: IRequestPaginatedOptions & { identityId?: string }): Promise<IPaginatedResponse<IModelIdentityItem>> {
    const { request } = useRequest();
    const params = formatRequestOptions(options);

    if (options.identityId) {
      params.sort = `media_parent_order.${options.identityId}`;
      // @ts-expect-error FIXME:
      params.filters = { identityId: options.identityId, media_type: "identity_item" };
    }

    return request
      .post<IPaginatedResponse<IResponseIdentity>>("/api/identity/list", { body: params })
      .then(response => formatPaginatedResponseItems(response, formatIdentityItem));
  },

  loadAllSubCategory(): Promise<IPaginatedResponse<IModelIdentityItem>> {
    const { request } = useRequest();
    const params = { filters: { media_type: "identity_item" }, page: 0, size: 100 };

    return request
      .post<IPaginatedResponse<IResponseIdentity>>("/api/identity/list", { body: params })
      .then(response => formatPaginatedResponseItems(response, formatIdentityItem));
  },

  async loadById(subCategoryId: string): Promise<IModelIdentityItem> {
    const { request } = useRequest();

    return await request
      .get<IContentResponse<IResponseIdentityItem>>(`/api/identity/get_by_id/id/${subCategoryId}`)
      .then(async (res) => {
        return formatIdentityItem(res.content);
      });
  },
};

export default SubCategoriesAPI;
